import { useCurrentWorkspaceId } from '@/entities/workspace';
import { useMutation } from '@tanstack/react-query';
import { deletePersona } from '../../api/persona-mutations.api';
import { track } from '@/shared/analytics';

interface Params {
  id: string;
}

export function useDeletePersona() {
  const workspaceId = useCurrentWorkspaceId();

  return useMutation({
    mutationFn: (params: Params) => {
      if (!workspaceId) throw new Error('No workspaceId found');

      return deletePersona(params.id, workspaceId);
    },
    onSuccess: (_data, params) => {
      track('persona_deleted', { persona_id: params.id });
    },
  });
}
